<form
  class="form"
  [formGroup]="formGroup()"
>
  @for (row of bankDetailsRowKeys; track $index) {
    @if (this.formGroup().get('passportExist')?.value || !row.isHidden) {
      <div
        class="form-row"
        [class]="row.className"
      >
        @for (field of getFieldsByRowKey(row.key); track $index) {
          @switch (field.type) {
            @case ('text') {
              <mat-form-field
                appearance="outline"
                [class]="getClasses(field.fieldName)"
              >
                <mat-label>{{ field.label }}</mat-label>
                <input
                  matInput
                  type="text"
                  [formControlName]="field.fieldName"
                  (blur)="handleInputChange(field.fieldName)"
                >
              </mat-form-field>
            }
            @case ('tel') {
              <mat-form-field
                appearance="outline"
                [class]="getClasses(field.fieldName)"
              >
                <mat-label>{{ field.label }}</mat-label>
                <input
                  matInput
                  appPhoneMask
                  type="text"
                  [formControlName]="field.fieldName"
                  (blur)="handleInputChange(field.fieldName)"
                >
              </mat-form-field>
            }
            @case ('number') {
              <mat-form-field
                appearance="outline"
                [class]="getClasses(field.fieldName)"
              >
                <mat-label>{{ field.label }}</mat-label>
                <input
                  matInput
                  appNumericInput
                  type="text"
                  [formControlName]="field.fieldName"
                  (blur)="handleInputChange(field.fieldName)"
                >
              </mat-form-field>
            }
            @case ('date') {
              <mat-form-field
                appearance="outline"
                [class]="getClasses(field.fieldName)"
              >
                <mat-label>{{ field.label }}</mat-label>
                <input
                  matInput
                  placeholder="ДД.ММ.ГГГГ"
                  appDateInput
                  [matDatepicker]="datePicker"
                  [formControlName]="field.fieldName"
                  (dateChange)="handleDateChange($event.value, field.fieldName, datePicker)"
                >
                <mat-datepicker-toggle
                  matSuffix
                  [for]="datePicker"
                >
                </mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
              </mat-form-field>
            }
            @case ('select') {
              <mat-form-field
                appearance="outline"
                [class]="getClasses(field.fieldName)"
              >
                <mat-label>{{ field.label }}</mat-label>
                <mat-select
                  [formControlName]="field.fieldName"
                  (selectionChange)="handleInputChange(field.fieldName)"
                >
                  <mat-option></mat-option>
                  @for (option of legalEntityTypes(); track option.id) {
                    <mat-option [value]="option.id">
                      {{ option.value }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @case ('button') {
              <div>
                <button
                  mat-flat-button
                  class="passport-exist"
                  [class]="getClasses(field.fieldName)"
                  [disabled]="!isEditModeActive()"
                  (click)="handleCheckboxChange(field.fieldName)"
                >
                  {{ field.label }}
                </button>
              </div>
            }
          }
        }
      </div>
    }
  }
  @if (currentBankDetailsIndex() >= 0 && bankDetailsDialogData()?.fromBloggerProfile) {
    <div class="buttons-container">
      <button
        mat-button
        color="warn"
        (click)="handleDeleteBankDetails(currentBankDetailsIndex())"
      >
        Удалить реквизиты
      </button>
    </div>
  }
  @if (selectedTabIndex() === 1) {
    <div class="buttons-container">
      <button
        mat-button
        color="primary"
        (click)="handleAttachClick.emit()"
      >
        Прикрепить
      </button>
    </div>
  }
</form>
